module.exports = __webpack_public_path__ + "static/img/top-bgimg.3aaa01c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anxiang/top-bgimg.png
// module id = xdyh
// module chunks = 1